export const inserted_by_options = [
    { value: 'customer', label: 'Privato' },
    { value: 'agency', label: 'Società' },
    // { value: 'cashouse', label: 'Cashouse' },
];

export const type_options = [
    { value: 'commercial', label: 'Commerciale' },
    { value: 'residential', label: 'Residenziale' },
];

export const typology_options = [
    { value: "apartment", label: "Appartamento" },
    { value: "villa", label: "Villa Indipendente" },
    { value: "attic", label: "Attico" },
    { value: "loft", label: "Loft/Open space" },
    { value: "mansard", label: "Mansarda" },
    { value: "townhouse", label: "Villeta a schiera" },
];

export const conditions_options = [
    { value: 'to_renovate', label: 'Da ristrutturare' },
    { value: 'good', label: 'Buono abitabile' },
    { value: 'renovated', label: 'Ristrutturato' },
    { value: 'new', label: 'Nuovo da impresa' },
];

export const deal_status_options = [
    { value: 'ok_proposal_accepted', label: 'Proposta accettata', badge: "badge-green" },
    { value: 'ok_deed', label: 'Rogito effettuato', badge: "badge-green" },
    { value: 'ko_sold_to_other', label: 'KO - Venduto ad altro acquirente', badge: "badge-red" },
    { value: 'ko_real_estate', label: 'KO - Real Estate', badge: "badge-red" },
    { value: 'ko_zone_not_served', label: 'KO - Zona non servita', badge: "badge-red" },
    { value: 'ko_proposal_not_accepted', label: 'KO - Proposta non accettata', badge: "badge-red" },
    { value: 'ko_proposal_accepted_with_reservation', label: 'KO - Proposta accettata con riserva', badge: "badge-red" },
    { value: 'ko_inspection_canceled', label: 'KO - Sopralluogo annullato', badge: "badge-red" },
    { value: 'pending_proposal_accepted_with_reservation', label: 'Pending - Proposta accettata con riserva', badge: "badge-yellow" },
    { value: 'pending_proposal_made', label: 'Pending - Proposta effettuata', badge: "badge-yellow" },
    { value: 'pending_real_estate_evaluation', label: 'Pending - In valutazione Real Estate', badge: "badge-yellow" },
    { value: 'pending_processing', label: 'Pending - In lavorazione', badge: "badge-yellow" },
    { value: 'pending_inspection_made', label: 'Pending - Sopralluogo effettuato', badge: "badge-yellow" },
    { value: 'pending_inspection_scheduled', label: 'Pending - Sopralluogo fissato', badge: "badge-yellow" },
    { value: 'dev', label: 'Operazione da sviluppare', badge: "badge-blue" },
];

export const status_options = [
    { value: 'new_lead', label: 'Nuova lead', badge: "badge-gray" },
    { value: 'call_center_ok', label: 'OK Call Center', badge: "badge-green" },
    { value: 'to_recall', label: 'Da richiamare', badge: "badge-yellow" },
    { value: 'not_responding', label: 'Non risponde', badge: "badge-yellow" },
    { value: 'wrong_number', label: 'Numero errato', badge: "badge-red" },
    { value: 'call_center_ko', label: 'KO Call Center', badge: "badge-red" },
];

export const apt_floor_options = [
    { value: 'basement', label: 'Seminterrato' },
    { value: 'ground_floor', label: 'Piano terra' },
    { value: 'mezzanine', label: 'Piano rialzato' },
    ...(() => {
        const ret = [];
        for (let i = 1; i <= 99; i++) {
            ret.push({ value: i, label: i, disabled: false });
        }
        return ret;
    })()
];

export const building_floors_options = [
    ...(() => {
        const ret = [];
        for (let i = 1; i <= 99; i++) {
            ret.push({ value: i, label: i, disabled: false });
        }
        return ret;
    })()
];

export const energy_class_options = [
    { value: 'A+', label: 'A+' },
    { value: 'A', label: 'A' },
    { value: 'B', label: 'B' },
    { value: 'C', label: 'C' },
    { value: 'D', label: 'D' },
    { value: 'E', label: 'E' },
    { value: 'F', label: 'F' },
    { value: 'G', label: 'G' },
    { value: 'not_classifiable', label: 'Non classificabile' },
    { value: 'idk', label: 'Non lo so' }
];

export const heating_options = [
    { value: 'centralized', label: 'Centralizzato' },
    { value: 'autonomous', label: 'Autonomo' },
    { value: 'nothing', label: 'Nessuno' },
    { value: 'idk', label: 'Non lo so' }
];

export const renovation_options = [
    { value: 'fractioning', label: 'Ristrutturazione base' },
    { value: 'complete_no_fixtures', label: 'Ristrutturazione intermedia' },
    { value: 'complete', label: 'Ristrutturazione completa' },
    { value: 'use_change', label: 'Cambio d\'uso' },
];

export const source_options = [
    { value: 'direct_contact', label: 'Contatto diretto' },
    { value: 'indirect_contact', label: 'Contatto indiretto' },
    { value: 'lead_web', label: 'Lead web' },
];

export const venue_typology_options= [
    { value: 'store', label: 'Negozio' },
    { value: 'office', label: 'Ufficio' },
];

export function findOptionLabel(options, optionValue) {
    const option = options.find(o => o.value == optionValue);
    if (option) return option.label;
    return '';
};

export function findOptionKey(options, optionValue, key) {
    const option = options.find(o => o.value == optionValue);
    if (option && key in option) return option[key];
    return '';
};
